import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { bannerVisible, getConsent, onConsentChange, setConsent } from "@/lib/analytics";

export function CookieBanner() {
  const [, force] = useState(0);
  useEffect(() => onConsentChange(() => force((n) => n + 1)), []);
  if (!bannerVisible()) return null;
  const current = getConsent();
  return (
    <div role="dialog" aria-labelledby="cookie-banner-title" data-testid="cookie-banner"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-[560px] rounded-[18px] border border-[var(--luma-line)] bg-white p-4 shadow-[0_12px_40px_rgba(20,35,61,.18)] sm:p-5">
      <p id="cookie-banner-title" className="font-display font-extrabold">Statistiche di visita</p>
      <p className="mt-1 text-sm text-[var(--luma-muted)]">
        Con il tuo consenso usiamo Google Analytics per capire, in forma aggregata, quali pagine vengono visitate. Se rifiuti, il sito funziona allo stesso modo.{" "}
        <Link to="/cookie" className="font-semibold text-[var(--luma-action)] underline" data-testid="cookie-banner-policy">Pagina cookie</Link>
        {current && <span data-testid="cookie-banner-current"> · Scelta attuale: {current === "granted" ? "statistiche accettate" : "statistiche rifiutate"}</span>}
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button type="button" className="luma-btn-ghost !min-h-[44px] !px-3 text-sm" data-testid="cookie-reject" onClick={() => setConsent("denied")}>Rifiuta</button>
        <button type="button" className="luma-btn-ghost !min-h-[44px] !px-3 text-sm" data-testid="cookie-accept" onClick={() => setConsent("granted")}>Accetta statistiche</button>
      </div>
    </div>
  );
}
